if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-media-direction]').forEach((button) => {
          button.addEventListener('click', () => this.changeMedia(Number(button.dataset.mediaDirection)));
        });
        this.addEventListener('keydown', (event) => {
          if (
            !this.hasAttribute('open') ||
            event.altKey ||
            event.ctrlKey ||
            event.metaKey ||
            event.target.closest('input, textarea, select, video, iframe, deferred-media, product-model, [contenteditable]')
          )
            return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.changeMedia(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      show(opener) {
        this.showActiveMedia(opener.getAttribute('data-media-id'));
        super.show(opener);
      }

      changeMedia(direction) {
        const mediaItems = this.mediaItems;
        if (mediaItems.length < 2) return;
        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
        window.pauseAllMedia();
        this.showActiveMedia(mediaItems[nextIndex].dataset.mediaId);
      }

      showActiveMedia(mediaId) {
        const mediaItems = this.mediaItems;
        const activeMedia = mediaItems.find((item) => item.dataset.mediaId === mediaId) || mediaItems[0];
        if (!activeMedia) return;

        mediaItems.forEach((item) => {
          const isActive = item === activeMedia;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
          item.inert = !isActive;
        });
        this.querySelectorAll('[data-media-direction]').forEach((button) => {
          button.hidden = mediaItems.length < 2;
        });
        this.querySelector('[data-media-current]').textContent = mediaItems.indexOf(activeMedia) + 1;
        this.querySelector('[data-media-total]').textContent = mediaItems.length;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
